"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const plugin_manager_service_1 = require("../../../../service/plugin-manager.service");
class PanelComponent {
    constructor(pluginManager) {
        this.pluginManager = pluginManager;
        this.context = null;
        this.parent = null;
        this.idx = 0;
        this.counter = 0;
    }
    ngOnInit() {
    }
    hasMenuItems() {
        // let state = this.context.state.state;
        if (this.context.props['menu']) {
            return true;
        }
        return false;
    }
    hasItems(idx = null) {
        let state = this.context.state.state;
        if (this.context.props['panels'] && this.context.props['panels'][state] && this.context.props['panels'][state][idx]) {
            if (this.context.props['panels'][state][idx]['length'] && this.context.props['panels'][state][idx].length > 0) {
                return true;
            }
        }
        return false;
    }
    isVisible(idx = null) {
        this.counter++;
        // let state = this.context.state.state;
        if (this.context && this.context.visual && this.context.config) {
            let mode = this.context.visual.state ? 'show' : 'hide';
            let showhide = this.context.config[mode];
            if (this.counter < 10) {
                console.log('!', mode, this.context.config, this.context.config[mode]);
            }
            // if ( s && s[idx] ) {
            return showhide[idx];
            // }
        }
        return false;
    }
    isHidden(idx = null) {
        let mode = !this.context.visual.state ? 'show' : 'hide';
        return this.context.config[mode][idx];
    }
}
exports.PanelComponent = PanelComponent;
